import IconUnavailable from '@apollo/icons/default/IconUnavailable.svg';
import classnames from 'classnames';
import React from 'react';

interface Props {
  title?: string;
  nosize?: boolean;
  className?: string;
  value?: string | number;
  unit?: string | null;
  label?: string;
}

export const Metric = ({
  className,
  nosize,
  title = '',
  value,
  unit,
  label,
}: Props) => (
  <div className={classnames('', className)} title={title}>
    <div
      className={classnames(
        'whitespace-nowrap',
        nosize ? '' : 'text-xl font-semibold',
      )}
      style={{ fontWeight: 400 }}
    >
      {value || value === 0 ? (
        <span>{value}</span>
      ) : (
        <IconUnavailable className="text-icon-disabled" />
      )}
      {unit ? (
        <span
          className={classnames('text-secondary', nosize ? '' : 'text-base')}
        >
          {' '}
          {unit}
        </span>
      ) : null}
    </div>
    {label ? (
      <div className={classnames('text-secondary', nosize ? '' : 'text-base')}>
        {label}
      </div>
    ) : null}
  </div>
);
